import './vendor/request-submit-polyfill';
import { Application } from '@hotwired/stimulus';
import "@hotwired/turbo";
import components from '../../_patterns/100-components';
import patterns from '../../_patterns/200-patterns';
import templates from '../../_patterns/300-templates';
import { init as utils, supportsCSSFlexBoxGap } from '../../_patterns/500-common/util';
import { AsyncController } from '../../_patterns/500-common/async.stimulus';
import { ClipboardController } from '../../_patterns/500-common/clipboard.stimulus';

init();

function init() {
    const globalConfig = (window as any).kltuiConfig as GlobalConfig;
    let publicRoot = globalConfig?.publicRoot || '';
    let vendorRoot = `${publicRoot}/assets/js/vendor`;

    const application = Application.start();

    featureDetection();

    components(vendorRoot, application);
    patterns(application);
    templates(application);
    utils();

    document.addEventListener('turbo:frame-load', () => {
        components(vendorRoot, application);
        patterns(application);
        templates(application);
    })

    AsyncController.register(application);
    ClipboardController.register(application);
}

interface GlobalConfig {
    publicRoot: string;
}

function featureDetection() {
    const documentClasses = [];

    if (!supportsCSSFlexBoxGap()) {
        documentClasses.push('no-flexbox-gap');
    }

    document.documentElement.classList.add(...documentClasses);
}
